module.exports = __webpack_public_path__ + "static/media/social_interaction.73823cb7.svg";